import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import SearchInputOptions from '../common/SearchInput/SearchInputOptions'
import TrackingStatus from '../common/TrackingStatus'
import DataTable from '../common/DataTable'
import Toaster from '../common/Toaster'
import DonwloadReportDialog from '../common/DonwloadReportDialog'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import DevolutionIcon from '@material-ui/icons/ReplyAllOutlined'
import AddIcon from '@material-ui/icons/AddTwoTone'
import IconButton from '@material-ui/core/IconButton'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Fab from '@material-ui/core/Fab'
import Tooltip from '@material-ui/core/Tooltip'

/** Language imports **/
import { Translate, getTranslate } from 'react-localize-redux'

/** Import section actions */
import {
	loadDevolutionsFromBackEnd,
	getDevolutiosCount,
	CHANGE_DEVOLUTION_SORT_CRITERIA,
	CHANGE_DEVOLUTIONS_QUERY,
	CHANGE_DEVOLUTIONS_PAGINATION,
	IS_LOADING_ALL_DEVOLUTIONS_REPORTS,
	downloadDevolutionsReport,
} from '../../store/devolutions/DevolutionActions'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import { converListToArray } from '../../store/helpers/ListHelper'
import { canUserCreateReportModuleQuality } from '../../store/helpers/RolesHelper'

/**
 * Devolutions  view
 *
 * @class Devolutions
 * @extends {Component}
 */
class Index extends Component {
	/**
	 * Create an instance Devolutions
	 * @param {*} props
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			openModalReport: false,
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		if (!this.props.isLoadingUser) {
			this.props.loadDevolutions(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage,
				this.props.isAllReports
			)
			this.props.getDevolutiosCount()
		}
	}

	/**
	 * componentDidUpdate
	 *
	 * @param {*} prevProps
	 * @param {*} prevState
	 * @memberof Index
	 */
	componentDidUpdate(prevProps, prevState) {
		let prevCompanyToken = prevProps.selectedCompany ? prevProps.selectedCompany.token : ''
		if (this.props.selectedCompany && prevCompanyToken !== this.props.selectedCompany.token) {
			this.props.loadDevolutions()
			this.props.getDevolutiosCount()
		} else if (
			prevProps.sortCriteria.by !== this.props.sortCriteria.by ||
			prevProps.sortCriteria.ascending !== this.props.sortCriteria.ascending ||
			prevProps.searchQuery !== this.props.searchQuery ||
			prevProps.page !== this.props.page ||
			prevProps.rowsPerPage !== this.props.rowsPerPage ||
			prevProps.isAllReports !== this.props.isAllReports
		) {
			this.props.loadDevolutions(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage,
				this.props.isAllReports
			)
		}
	}

	/**
	 * On change sort criteria
	 *
	 * @param {*} sortBy
	 * @param {*} sortAscending
	 * @memberof Index
	 */
	onChangeSortCriteria(sortBy, sortAscending) {
		this.props.changeSortCriteria(sortBy, sortAscending)
	}

	/**
	 * On change search value
	 *
	 * @param {*} searchQuery
	 * @memberof Index
	 */
	onChangeSearchValue(searchQuery) {
		this.props.onLoadingAllReports(false)
		this.props.changeSearchQuery(searchQuery)
	}

	/**
	 * On change get all reports
	 */
	onChangeGetAllReports() {
		this.props.onLoadingAllReports(true)
	}

	/**
	 * Method to custom render in datalist
	 *
	 * @param {*} dataSource
	 * @param {*} item
	 * @returns
	 * @memberof Index
	 */
	onRenderCellItem(dataSource, item) {
		if (dataSource === 'tracking') {
			return <TrackingStatus tracking={item.tracings} />
		}
	}

	/**
	 * Open modal for download devolutions report by mont
	 *
	 * @memberof Index
	 */
	handleOpenModal() {
		this.setState({
			openModalReport: true,
		})
	}

	/**
	 * Get the card content
	 *
	 * @memberof Index
	 */
	getCardContent() {
		const { sortCriteria } = this.props
		if (this.props.isLoadingDevolutions === true) {
			return <LoadingPage />
		} else if (this.props.devolutions === null) {
			return (
				<div className='loader-container'>
					<Typography variant='subtitle1' gutterBottom>
						{' '}
						<Translate id='common.errorToGetInformation' />
					</Typography>
				</div>
			)
		} else {
			let tableConfiguration = TableInternalConfiguration
			if (!IsCurrentActiveDirectoryUser(this.props.user)) {
				tableConfiguration = TableExternalConfiguration
			}
			return (
				<DataTable
					data={this.props.devolutions}
					configuration={tableConfiguration}
					sortBy={sortCriteria.by}
					sortAscending={sortCriteria.ascending}
					onChangeSortCriteria={this.onChangeSortCriteria}
					onRenderCellItem={this.onRenderCellItem}
					onRowClick={(devolution) => {
						this.props.history.push(`/devolutions/${devolution.token}`)
					}}
					showFilters
					isIndex
					totalRows={this.props.devolutionsCount}
					page={this.props.page}
					rowsPerPage={this.props.rowsPerPage}
					onChangePage={(newPage, newRowsPerPage) => {
						this.props.changePage(newPage, newRowsPerPage)
					}}
				/>
			)
		}
	}

	/**
	 * Get Devolutions counter
	 *
	 * @returns
	 * @memberof Index
	 */
	getCounterMessage() {
		if (this.props.devolutions) {
			let totalDevolutions = this.props.devolutions.length
			return (
				<div>
					{this.props.translate('common.showing')}&nbsp;
					<span>{totalDevolutions}</span>&nbsp;
					{this.props.translate('common.of')}&nbsp;
					<span>{this.props.devolutionsCount}</span>&nbsp;
					{this.props.translate('common.records')}
					<br />
					{this.props.translate('devolutions.folioTracking')}
				</div>
			)
		}
	}

	/**
	 * Method to show succes toaster
	 * with custom message or default "saveCorrectly"
	 *
	 * @param {string} [idTranslation="common.saveCorrectly"]
	 * @memberof Show
	 */
	showSuccessToaster(idTranslation = 'common.saveCorrectly') {
		this.setState({
			showToaster: true,
			toasterVariant: 'success',
			toasterMessage: <Translate id={idTranslation} />,
		})
	}

	/**
	 *On download report DEVOLUTIONS
	 *
	 * @memberof Index
	 */
	handleDownloadReportDevolutions(startDate, endDate) {
		return this.props
			.downloadDevolutionsReport(startDate, endDate)
			.then(() => {
				this.setState({
					openModalReport: false,
				})
				this.showSuccessToaster('common.downloadCorrectly')
			})
			.catch(() => {
				this.showErrorToaster('common.errorToDownload')
			})
	}

	/**
	 * Render
	 *
	 * @returns
	 * @memberof Devolutions
	 */
	render() {
		const { classes } = this.props
		return (
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<DevolutionIcon />
						</Avatar>
					}
					action={
						<div className={classes.actionsToolbar}>
							<SearchInputOptions
								className={classes.searchInput}
								onChangeSearchValue={this.onChangeSearchValue}
								value={this.props.searchQuery}
								isSearchAllReports
								onSearchAllReports={this.onChangeGetAllReports}
							/>

							{IsCurrentActiveDirectoryUser(this.props.user) &&
								canUserCreateReportModuleQuality(this.props.userRolesByCompany) && (
									<Tooltip title={<Translate id='devolutions.addDevolution' />}>
										<Fab
											size='small'
											color='primary'
											onClick={() => {
												this.props.history.push(`/devolutions/create`)
											}}
										>
											<AddIcon />
										</Fab>
									</Tooltip>
								)}

							{IsCurrentActiveDirectoryUser(this.props.user) && (
								<Tooltip title={<Translate id='rawmaterialnonconformity.downloadReport' />}>
									<IconButton
										// disabled={this.props.isLoading}
										onClick={() => this.handleOpenModal()}
										color='secondary'
									>
										<DownloadIcon />
									</IconButton>
								</Tooltip>
							)}
						</div>
					}
					title={
						<Typography variant='button'>
							<Translate id='menu.devolutions' />{' '}
						</Typography>
					}
					subheader={this.getCounterMessage()}
				/>
				<CardContent>{this.getCardContent()}</CardContent>
				<Toaster
					message={this.state.toasterMessage}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>

				{/** Dialog to download report */}
				<DonwloadReportDialog
					title={<Translate id='devolutions.downloadReportGeneral' />}
					open={this.state.openModalReport}
					onClose={() => {
						this.setState({
							openModalReport: false,
						})
					}}
					isSaving={this.props.isLoading}
					onDonwloadItems={this.handleDownloadReportDevolutions}
				/>
			</Card>
		)
	}
}

const TableInternalConfiguration = {
	columns: [
		{
			header: '',
			dataSource: 'status_indicator',
		},
		{
			header: '',
			dataSource: 'tracking',
		},
		{
			header: <Translate id='common.status' />,
			dataSource: 'actual_operation_description',
			isSortable: true,
		},
		{
			header: <Translate id='common.folio' />,
			dataSource: 'folio',
			isSortable: true,
		},
		{
			header: <Translate id='common.creationDate' />,
			dataSource: 'creation_date',
			isSortable: true,
		},
		{
			header: <Translate id='common.preparedBy' />,
			dataSource: 'responsible',
			isSortable: true,
		},
		{
			header: <Translate id='common.supplier' />,
			dataSource: 'full_supplier',
			isSortable: true,
		},
		{
			header: <Translate id='common.partNumber' />,
			dataSource: 'part_number',
		},
		{
			header: <Translate id='devolutions.provenance' />,
			dataSource: 'get_provenance',
		},
	],
}

const TableExternalConfiguration = {
	columns: [
		{
			header: '',
			dataSource: 'status_indicator',
		},
		{
			header: '',
			dataSource: 'tracking',
		},
		{
			header: <Translate id='common.status' />,
			dataSource: 'actual_operation_description',
			isSortable: true,
		},
		{
			header: <Translate id='common.folio' />,
			dataSource: 'folio',
			isSortable: true,
		},
		{
			header: <Translate id='common.creationDate' />,
			dataSource: 'creation_date',
			isSortable: true,
		},
		{
			header: <Translate id='common.preparedBy' />,
			dataSource: 'responsible',
			isSortable: true,
		},
		{
			header: <Translate id='common.partNumber' />,
			dataSource: 'part_number',
		},
		{
			header: <Translate id='devolutions.provenance' />,
			dataSource: 'get_provenance',
		},
	],
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
	let selectedCompany = state.profile.get('selectedCompany')
	let userRolesByCompany = state.profile.get('userRolesByCompany')
	return {
		user: user,
		selectedCompany: selectedCompany ? selectedCompany.toJS() : null,
		isLoadingUser: state.oidc.isLoadingUser,
		isLoadingDevolutions: state.devolutions.get('isLoadingDevolutions'),
		isLoading: state.devolutions.get('isLoading'),
		devolutions: state.devolutions.get('devolutions') ? state.devolutions.get('devolutions').toJS() : null,
		sortCriteria: state.devolutions.get('sortCriteria') ? state.devolutions.get('sortCriteria').toJS() : null,
		searchQuery: state.devolutions.get('searchQuery'),
		page: state.devolutions.get('page'),
		rowsPerPage: state.devolutions.get('rowsPerPage'),
		devolutionsCount: state.devolutions.get('devolutionsCount'),
		translate: getTranslate(state.localize),
		userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
		isAllReports: state.devolutions.get('isAllDevolutionsReports'),
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadDevolutions: (query, orderBy, sortAscending, page, rowsPerPage, isAllReports) => {
			dispatch(loadDevolutionsFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage, isAllReports))
		},
		changeSortCriteria: (sortBy, sortAscending) => {
			dispatch({
				type: CHANGE_DEVOLUTION_SORT_CRITERIA,
				sortCriteria: {
					by: sortBy,
					ascending: sortAscending,
				},
			})
		},
		changeSearchQuery: (query) => {
			dispatch({
				type: CHANGE_DEVOLUTIONS_QUERY,
				query: query,
			})
		},
		onLoadingAllReports: (isAllReports) => {
			dispatch({
				type: IS_LOADING_ALL_DEVOLUTIONS_REPORTS,
				isAllReports,
			})
		},
		changePage: (page, rowsPerPage) => {
			dispatch({
				type: CHANGE_DEVOLUTIONS_PAGINATION,
				page,
				rowsPerPage,
			})
		},
		getDevolutiosCount: () => {
			dispatch(getDevolutiosCount())
		},
		downloadDevolutionsReport: (startDate, endDate) => {
			return dispatch(downloadDevolutionsReport(startDate, endDate))
		},
	}
}

const styles = (theme) => ({
	avatar: {},
	actionsToolbar: {
		display: 'flex',
	},
	searchInput: {
		marginTop: '5px',
	},
	showingUsersCounter: {
		color: theme.palette.secondary.main,
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Index)))
)
